/* src/app/modules_v2/booking/locations/components/location-detail/location-detail.component.css */
.spacer {
  flex: 1 1 auto;
}
.mt-4 {
  margin-top: 24px;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}
mat-card,
.mat-mdc-card {
  margin-bottom: 16px;
}
.tab-content {
  padding: 20px 0;
  min-height: 400px;
}
mat-tab-group,
.mat-mdc-tab-group {
  margin-top: 16px;
}
/*# sourceMappingURL=location-detail.component.css.map */
